import { render, staticRenderFns } from "./OrgDetailsCompany.vue?vue&type=template&id=1a031cde&"
import script from "./OrgDetailsCompany.vue?vue&type=script&lang=js&"
export * from "./OrgDetailsCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports